import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LockedFeatureModalComponent } from './locked-feature-modal.component';
import { ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [LockedFeatureModalComponent],
  imports: [CommonModule, ButtonModule],
  exports: [LockedFeatureModalComponent],
})
export class LockedFeatureModalModule {}
